export default __webpack_public_path__ + "static/media/devices_cropped.b237d1f1.png";